var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.elements),function(i,index){return _c('div',{key:index,staticClass:"layer2",style:({
      top: i.top + 'mm',
      left: i.left + 'mm',
      width: i.width + 'mm',
      height: i.height + 'mm',
    })},[_c('div',{style:({ color: i.content.color })},[(i.content.icon)?_c('div',{staticClass:"icon-box"},[_c('div',[(
              i.style.constrain == 1 ||
              i.style.constrain == 4 ||
              i.style.constrain == 5
            )?_c('i',{staticClass:"iconfont2",class:i.content.icon,style:({
              fontSize: i.iconSize + 'mm',
              position: 'absolute',
              left: i.iconCords.x - i.iconSize / 2 - 2 + 'mm',
              top: i.iconCords.y - i.iconSize / 2 - 2 + 'mm',
            })}):_vm._e()])]):_vm._e(),(i.content.textL1 || i.content.textL2)?_c('div',{staticClass:"text-box"},[_c('div',[(
              i.style.constrain == 2 ||
              i.style.constrain == 3 ||
              i.style.constrain == 4 ||
              i.style.constrain == 5
            )?_c('p',{ref:'textL1_' + i.id,refInFor:true,style:({
              fontSize: i.fontSize + 'px',
              position: 'absolute',
              left: i.textCords.x - _vm.textL1width['textL1_' + i.id] + 'mm',
              top: i.textCords.y - 2 + 'mm',
              whiteSpace: 'pre',
              letterSpacing: _vm.letterSpacing,
              fontKerning: 'none'
            })},[_vm._v(_vm._s(i.content.textL1))]):_vm._e(),(i.style.constrain == 3 || i.style.constrain == 5)?_c('p',{ref:'textL2_' + i.id,refInFor:true,style:({
              fontSize: i.fontSize + 'px',
              position: 'absolute',
              left: i.textCords.x - _vm.textL2width['textL2_' + i.id] + 'mm',
              top: i.textCords.y - 2 + i.textL2Offset + 'mm',
              whiteSpace: 'pre',
              letterSpacing: _vm.letterSpacing,
            })},[_vm._v(_vm._s(i.content.textL2))]):_vm._e()])]):_vm._e()])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }